// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthCapabilityAssignment\ApiBerthCapabilityAssignment.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Berth, BerthData, BerthOptions } from 'data/models/Berth';
import { BerthCapability, BerthCapabilityData, BerthCapabilityOptions } from 'data/models/BerthCapability';

// BerthCapabilityAssignmentData is the class that BerthCapabilityAssignment serializes to/from
export interface BerthCapabilityAssignmentData {
    Id : number;
    Url : string | null;
	
    Berth : BerthData | null;
    BerthId : number;
    Capability : BerthCapabilityData | null;
    CapabilityId : number;
	
    Guid : /* GUID */ string;
}

// BerthCapabilityAssignmentOptions is the class which may be passed to the BerthCapabilityAssignment constructor to define optional initial data values
export interface BerthCapabilityAssignmentOptions {
    Id : number;
    Url? : string | null;
	
    Berth? : BerthOptions | null;
    BerthId? : number;
    Capability? : BerthCapabilityOptions | null;
    CapabilityId? : number;
	
    Guid? : /* GUID */ string;
}

export class BerthCapabilityAssignment {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Berth : DataSignal<Berth | null>;
    public BerthId : DataSignal<number>;
    public Capability : DataSignal<BerthCapability | null>;
    public CapabilityId : DataSignal<number>;
	
    public Guid : DataSignal<string>;

    constructor();
    constructor(data : BerthCapabilityAssignmentOptions);
    constructor(data: BerthCapabilityAssignmentOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Berth = S.value<Berth | null>(null);
        this.BerthId = jsonableObservable(S.value<number>(data && data.BerthId !== undefined ? data.BerthId : 0));
        this.Capability = S.value<BerthCapability | null>(null);
        this.CapabilityId = jsonableObservable(S.value<number>(data && data.CapabilityId !== undefined ? data.CapabilityId : 0));
	    
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
    }

    static key(obj : BerthCapabilityAssignment) {
        return obj.Id();
    }
    
    static dataKey(obj : BerthCapabilityAssignmentOptions) {
        return obj.Id;
    }

    static update(obj : BerthCapabilityAssignment, data : BerthCapabilityAssignmentOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.BerthId !== undefined) obj.BerthId(data.BerthId);
            if (data.CapabilityId !== undefined) obj.CapabilityId(data.CapabilityId);
	        
            if (data.Guid !== undefined) obj.Guid(data.Guid);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BerthCapabilityAssignment.ts